module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('router-link', {
    staticClass: "big-btn blue",
    attrs: {
      "to": {
        path: '/admin/testimonials'
      }
    }
  }, [_vm._v("\n        Add New Testimonial\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.testimonials), function(test, index) {
    return _c('div', {
      key: test.id,
      staticClass: "colum one_half"
    }, [_c('blockquote', [_c('p', [_c('span', {
      staticClass: "dropcap"
    }, [_vm._v(_vm._s(index))]), _vm._v("\n            " + _vm._s(test.content) + "\n          ")]), _vm._v(" "), _c('cite', [_vm._v(_vm._s(test.author) + ",  "), _c('b', [_vm._v(_vm._s(test.type))])])]), _vm._v(" "), _c('router-link', {
      staticClass: "big-btn red",
      attrs: {
        "to": {
          path: '/admin/testimonial/' + test.id
        }
      }
    }, [_vm._v("\n          Edit\n        ")]), _vm._v(" "), _c('a', {
      staticClass: "big-btn red",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(test)
        }
      }
    }, [_vm._v("Delete")])], 1)
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40de4fb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/ManageTestimonial.vue
// module id = 495
// module chunks = 1